<template>
  <section>
    <div class="item">
      <div class="header">
        <span class="header_title">Claim Method - Claim Tickets</span>
        <div>
          <v-button
            v-if="!isMethod"
            gray
            @click="handleAddFile(1)">Change Method</v-button>
          <template v-else>
            <v-button
              gray
              @click="handleCancel">Cancel</v-button>
            <v-button
              green
              @click="handleSave">Save</v-button>
          </template>
        </div>
      </div>
      <template   v-if="!isMethod">
        <template v-if="detailData.type==1||detailData.type==3">
          <p class="fs-14 color-dark mg-b-20 mg-t-20">Using claim tickets to handle claim requests</p>
          <div
            class="table_group">
            <div class="fileTable table_item">
              <div class="tr bold">
                <div class="td name file_name">Claim Form</div>
                <div class="td name file_name">Uploaded  Date</div>
              </div>
              <template>
                <div
                  class="empty tr"
                  @click="handleType(detailData)">
                  <div class="td name">
                    <div
                      v-if="!detailData.claim_en_form_path_id||!detailData.claim_zh_form_path_id"
                      class="pct">No claim form upload</div>
                    <div
                      v-else
                      class="pct blue">
                      <span class="inline-block mg-r-15">en: {{claim_en_form.client_name||'-'}}</span>
                      <span class="inline-block">zh: {{claim_zh_form.client_name||'-'}}</span>
                    </div>
                  </div>
                  <div class="td name">
                    <div class="pct">{{detailData.created_date||'-'}}</div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template  v-if="detailData.type==2||detailData.type==3">
          <p class="fs-14 color-dark mg-b-20 mg-t-20">Claim requests are handled by Insurer</p>
          <method-detail
            :detail-data="detailData"
            @method="handleChangeMethod"></method-detail>
        </template>
      </template>
      <change-method
        v-else
        ref="change-method"
        :detailData="detailData"
        @success="handleSuccess"></change-method>
    </div>

  </section>
</template>

<script>
import {addRate, getInsurerPlanDetail, editRate, delRate} from '@/api/account'
import ChangeMethod from './change-method'
import MethodDetail from './method-detail'
import {getInsurersClaimDetail} from '@api/claim'
export default {
  name: 'claimMethod',
  components:{
    ChangeMethod,
    MethodDetail
  },
  data () {
    return {
      type: 1,
      detailData:{},
      rowData:{},
      isMethod:false,
      showDetail:false,
      claimId:0
    }
  },
  computed:{
    claim_en_form(){
      let{claim_en_form} = this.detailData||{}
      return claim_en_form||{}
    },
    claim_zh_form(){
      let{claim_zh_form} = this.detailData||{}
      return claim_zh_form||{}
    },
    options(){
      return this.$route.query || null
    },
    company_id(){
      let {company_id} = this.$route.query||{}
      return company_id
    },
    class_id(){
      let {class_id} = this.$route.query||{}
      return class_id
    },
    plan_id(){
      let {plan_id} = this.$route.query||{}
      return plan_id
    },
  },
  watch:{
    options:{
      immediate: true,
      deep: true,
      handler(val){
        if(val){
          this.network().getInsurersClaimDetail()
        }
      }
    }
  },
  methods: {
    handleDetail(item){
      let {id} = item
      this.claimId = id
      this.showDetail = true
    },
    handleType(){
      // let {type} = this.detailData||{}
      // if(type==1){
      //   this.isMethod = true
      // }else {
      //   this.showDetail = true
      // }
    },
    handleAddFile(type){
      this.isMethod = true
      this.showDetail = false
      this.rowData = {}
    },
    handleCancel(params){
      this.isMethod = false
      this.showDetail = false
    },
    handleSuccess(params){
      this.isMethod = false
      this.showDetail = false
      this.network().getInsurersClaimDetail()
    },
    handleSave(params){
      this.$refs['change-method'].submitForm()
      // this.isMethod = false
    },
    updateDetail(){
      this.network().getInsurersClaimDetail()
    },
    handleChangeMethod(id){
      this.isMethod = true
      this.showDetail = false
    },
    handleStartNow(row){
      let params = {
        id: row.id
      }
      this.network().editRate(params)
    },
    handleEdit(row){
      this.$set(this, 'rowData', row)
    },
    handleDel(row){
      let params = {
        id: row.id
      }
      this.network().delRate(params)
    },
    saveEdit(params){
      this.network().editRate(params)
    },
    network(){
      return {
        getInsurersClaimDetail: async (params) => {
          params = {
            company_id:this.company_id,
            class_id:this.class_id,
            plan_id:this.plan_id,
          }
          const { data } = await getInsurersClaimDetail(params)
          this.detailData = data
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.item{
  .header{
    display: flex;
    justify-content: space-between;
    .header_title{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .table_group{
    margin-top: 20px;
    .table_item{
      .tr{
        background: #FFFFFF;
        border: 1px solid #D1D5DA;
        min-height: 40px;
        display: flex;
        padding: 10px 15px;
        .td{
          flex: 1;
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 14px;
          min-height: 20px;
          color: #24292E;
          &.name{
            flex: 1;
            word-break: break-word;
            .pct{
              font-weight: 600;
              font-size: 14px;
            }
          }
          &.center{
            //flex: 2;
            min-width: 200px;
            justify-content: center;
          }
          &.operation{
            min-width: 200px;
            justify-content: flex-end;
            color: #0366D6;
            .del{
              color: #CB2431;
            }
            span+span{
              margin-left: 15px;
            }
          }
          .file_name{
            font-weight: 600;
            color: #0366D6;
          }
          .icon{
            border-radius: 100px;
            height: 20px;
            padding: 1px 8px;
            margin-left: 15px;
            font-weight: 600;
            text-align: center;
            min-width: 70px;
            &.green{
              border: 1px solid #28A745;
              color: #22863A;
            }
            &.gray{
              border: 1px solid #6A737D;
              color: #24292E;
            }
          }
        }
        &.bold{
          background: #F6F8FA;
          .td{
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #24292E;
          }
        }
        &.empty{
          justify-content: center;
          color: #909399;
          font-size: 14px;
        }
        &.blue_bg{
          background: #F1F8FF;
        }
        &:first-child{
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        &:last-child{
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        &+.tr{
          border-top: 0;
        }
      }
    }
    .oldFileTable{
      margin-top: 30px;
    }
  }
}
</style>
